"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
var _ossUpload = require("@/utils/ossUpload");
var _appSetting = require("@/api/appSetting");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  data: function data() {
    return {
      activeName: 'android',
      dataObj: {
        androidFileList: [],
        androidPackageName: '',
        androidPsd: '',
        androidBookName: '',
        bcPhotoList: [],
        iosPackageName: '',
        iosFileList: [],
        iosMobileprovisionFileList: [],
        iosPsd: '',
        iosBcPhotoList: [],
        ios_bc_AppKey: '',
        harmonyPackageName: '',
        harmony_myk_psd: '',
        harmony_my_psd: '',
        harmony_my_name: '',
        harmony_myk_FileList: [],
        harmony_ProfileList: [],
        harmonyFileList: [],
        harmony_bc_AppKey: '',
        harmonyBcPhotoList: []
      }
    };
  },
  mounted: function mounted() {
    var _this = this;
    (0, _appSetting.getManifest)({
      type: 'packConfig'
    }).then(function (res) {
      if (res.data) {
        var obj = JSON.parse(res.data);
        Object.keys(obj).forEach(function (key) {
          if (_this.dataObj.hasOwnProperty(key)) {
            _this.dataObj[key] = obj[key];
          }
        });
        // this.dataObj = { ...obj }
      }
    });
  },
  methods: {
    save: function save() {
      var _this2 = this;
      this.$confirm('确认是否要保存？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _appSetting.saveManifest)({
          packConfig: JSON.stringify(_this2.dataObj, null, 2)
        }).then(function (res) {
          if (res.data) {
            _this2.$notify.success({
              title: '温馨提示',
              message: '操作成功！'
            });
          }
        });
      }).catch(function () {
        _this2.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(file, fileName, val) {
        var pictureUrl, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return (0, _ossUpload.uploadOSS)(file.file, 'builds', fileName);
            case 1:
              pictureUrl = _context.v;
              console.log(pictureUrl);
              _t = val;
              _context.n = _t === 1 ? 2 : _t === 2 ? 3 : _t === 3 ? 4 : _t === 4 ? 5 : _t === 5 ? 6 : _t === 6 ? 7 : _t === 7 ? 8 : _t === 8 ? 9 : _t === 9 ? 10 : 11;
              break;
            case 2:
              this.dataObj.androidFileList = [{
                name: file.file.name,
                url: pictureUrl
              }];
              return _context.a(3, 11);
            case 3:
              this.dataObj.bcPhotoList = [{
                name: file.file.name,
                url: pictureUrl
              }];
              return _context.a(3, 11);
            case 4:
              this.dataObj.iosFileList = [{
                name: file.file.name,
                url: pictureUrl
              }];
              return _context.a(3, 11);
            case 5:
              this.dataObj.iosMobileprovisionFileList = [{
                name: file.file.name,
                url: pictureUrl
              }];
              return _context.a(3, 11);
            case 6:
              this.dataObj.iosBcPhotoList = [{
                name: file.file.name,
                url: pictureUrl
              }];
              return _context.a(3, 11);
            case 7:
              this.dataObj.harmony_myk_FileList = [{
                name: file.file.name,
                url: pictureUrl
              }];
              return _context.a(3, 11);
            case 8:
              this.dataObj.harmony_ProfileList = [{
                name: file.file.name,
                url: pictureUrl
              }];
              return _context.a(3, 11);
            case 9:
              this.dataObj.harmonyFileList = [{
                name: file.file.name,
                url: pictureUrl
              }];
              return _context.a(3, 11);
            case 10:
              this.dataObj.harmonyBcPhotoList = [{
                name: file.file.name,
                url: pictureUrl
              }];
            case 11:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function handleFileUpload(_x, _x2, _x3) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    handleRemove: function handleRemove(file, val) {
      switch (val) {
        case 1:
          this.dataObj.androidFileList = [];
          break;
        case 2:
          this.dataObj.bcPhotoList = [];
          break;
        case 3:
          this.dataObj.iosFileList = [];
          break;
        case 4:
          this.dataObj.iosMobileprovisionFileList = [];
          break;
        case 5:
          this.dataObj.iosBcPhotoList = [];
          break;
        case 6:
          this.dataObj.harmony_myk_FileList = [];
          break;
        case 7:
          this.dataObj.harmony_ProfileList = [];
          break;
        case 8:
          this.dataObj.harmonyFileList = [];
          break;
        case 9:
          this.dataObj.harmonyBcPhotoList = [];
      }
    }
  }
};